import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapRequirementOptions = (
  option: UCM.ContractRequirementOptionRawType,
): UCM.ContractRequirementOptionType => ({
  value: option.code,
  label: option.name,
});

const getRequirementOptions = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.ContractRequirementOptionRawType>
  >(API.GET.contractRequirementOptions, {
    headers: { Accept: 'application/vnd.falcon.v2+json' },
  });
  return data.data.map(({ attributes }) => mapRequirementOptions(attributes));
};

export const useGetRequirementOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CONTRACT_REQUIREMENT_OPTIONS],
    queryFn: getRequirementOptions,
    staleTime: 1000 * 60 * 10,
    ...config,
  });
};
